import { createContext } from 'react';
import type { Workflow } from 'src/pages/ConfigurationPage/WorkflowsTab/workflowFormValues';

// The custom workflow being edited, with its position in the custom workflow list.
export type SelectedWorkflow = Workflow & { index: number };

export interface ConfigurationContextValue {
  isEditWorkflowMode: boolean;
  setIsEditWorkflowMode: (isEditWorkflowMode: boolean) => void;
  selectedWorkflow: SelectedWorkflow | null;
  setSelectedWorkflow: (selectedWorkflow: SelectedWorkflow | null) => void;
}

export const ConfigurationContext = createContext<ConfigurationContextValue | null>(null);
